var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-facebook-login',{attrs:{"app-id":"309102442977190"},on:{"login":_vm.logged}})
}
var staticRenderFns = []

export { render, staticRenderFns }